import React from 'react';
import { Box, Card, CardContent, List, ListItem, ListItemText, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { themeColors } from '../../constants/theme';
import { useTranslation } from 'react-i18next';
import { useWindowSize } from '../useWindowSize';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop:  theme.spacing(-4),
    zIndex: 1,
    flexGrow: 1,
  },
  card: {
    [theme.breakpoints.up('xs')]: {
      marginBottom: `${theme.spacing(2)}px`,
    },
    [theme.breakpoints.up('md')]: {
      margin: `0 ${theme.spacing(2)}px`,
    },
    // backgroundColor: 'orange', 
    borderTop: `2px solid ${themeColors.yellow}`,
    borderRadius: theme.shape.borderRadius,  
  },
  cardFormat: {
    backgroundColor: `${themeColors.topIndexGray}`, 
  },
  cardContent: {
    margin: `0 ${theme.spacing(1)}px`,
    paddingTop: `5px`,
    paddingBottom: `${theme.spacing(1)}`,
    paddingLeft: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
    justifyContent: 'space-between',
  },
    title: {
        marginLeft: theme.spacing(1),
        marginTop: theme.spacing(2),
    },
}));

interface IProps {
  onCreateReport: any;
}

export default function GeneralMachineDataHeader(props: IProps) {
  const classes = useStyles();
  const { t } = useTranslation();
  const size = useWindowSize();
  const isSmallScreen =
    size.width !== undefined && size.width > 600 && size.width < 800
      ? true
      : false;


  return (
    <div className={classes.root}>
      <div className={classes.card}>
        <Card className={classes.cardFormat}
          style={isSmallScreen ? { marginTop: 0 } : { marginTop: 'inherit' }}
        >
          <CardContent
            className={classes.cardContent}
          >
            <Typography
                variant="h5"
                className={classes.title}
            >
                {t('graph.machineData')}
            </Typography>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
